<template>
    <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg');">
        <div class="card bg-card-trans border-0 rounded-0 mobile-ver">
            <div class="mobile-ver-top mobile-ver-top-2">
                <div class="d-flex align-items-center h-100 justify-content-between px-3">
                    <div class="d-flex align-items-center">
                        <a href="javascript:void(0)" class="btn btn-white-naked btn-icon me-md-3 me-2" v-on:click="goToPage('dashboard_student')">
                            <i class="fa-solid fa-arrow-left"></i>
                        </a>
                        <div class="d-block display-tektur h1 m-0">Minat Bakat</div>
                    </div>
                </div>
            </div>
            <div class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                <div class="d-block px-md-4 px-3 pt-md-4 pt-3">
                    <div class="d-block mb-3">
                        <div class="card-body">
                            <div class="d-block text-center p-md-4">
                                <img src="assets/img/dashboard-icon-8.png" alt="Minat Bakat" width="140">
                                <div class="d-block text-center">
                                    <div class="d-block mb-2 display-tektur text-md">Fitur belum tersedia</div>
                                    <div class="d-block">Waduh, sepertinya fitur yang kamu cari masih disiapin. Tungguin
                                        ya, bakal ada kabar baik segera! ✨ 🚀</div>
                                    <!-- <div class="d-block">
                                            <a href="detail-alumni-siswa.php" class="btn btn-s-1 btn-primary">
                                                <div class="btn-s-1-inner">Kembali ke halaman utama</div>
                                            </a>
                                        </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="d-block p-md-4">
                                <div class="d-flex align-items-center mb-4">
                                    <i class="fa-solid fa-circle-question fa-2x text-pink flex-shrink-0 me-3"></i>
                                    <div class="d-block font-bold text-pink">Apa yang bakal ada di fitur ini?</div>
                                </div>
                                <div class="d-block">
                                    <p>Buat masuk universitas, nggak cuma nilai yang diitung, tapi juga minat bakat
                                        kita. Jadi, kalo kamu punya keahlian atau hobbi yang kamu suka banget, itu bisa
                                        jadi jalan buat masukin ke kampus impian. Jadi, belajar nggak cuma soal buku
                                        doang, tapi bisa sesuai sama passion kita. Asik, kan?</p>
                                </div>
                                <div class="d-block text-sm">
                                    <div class="d-flex align-items-center border-top pt-3 mt-3">
                                        <i class="fa-solid fa-check-circle flex-shrink-0 text-neon me-3"></i>
                                        <div class="d-block"><span class="font-bold">Bukan Hanya Nilai:</span>
                                            Universitas nggak cuma lihat nilai doang, tapi juga minat bakat kita.</div>
                                    </div>
                                    <div class="d-flex align-items-center border-top pt-3 mt-3">
                                        <i class="fa-solid fa-check-circle flex-shrink-0 text-neon me-3"></i>
                                        <div class="d-block"><span class="font-bold">Pintu Masuk ke Jurusan
                                                Impian:</span> Misalnya, kalo kita suka banget sama musik, bisa jadi
                                            jalan masuk ke jurusan yang kita pengen.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
  export default {
    name: 'StudentTalent',
    methods: {
        goToPage: function(params=null) {
            this.$router.push( {
                name : params
            })            
        }
    }
  }
</script>